
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.973 17.618h-5.98a.665.665 0 01-.664-.665V4.993c0-.366.298-.664.664-.664h5.98a.664.664 0 100-1.329h-5.98A1.996 1.996 0 002 4.993v11.96c0 1.1.894 1.994 1.993 1.994h5.98a.664.664 0 100-1.329z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M17.803 10.498l-4.04-3.986a.664.664 0 10-.933.946l2.887 2.849H7.981a.664.664 0 100 1.329h7.736l-2.887 2.849a.664.664 0 10.933.946l4.04-3.987a.666.666 0 000-.946z","fill":"currentColor"}})])
          )
        }
      }
    